import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  n: '1',
  title: 'Instant download',
  desc: 'Purchase and get immediate access to the complete 6-volume digital book and all 5 bonuses. Start whenever you want, no waiting.'
}, {
  n: '2',
  title: 'Decompress and unlock progressively',
  desc: 'Identify your pain severity, create a zero-gravity environment for your spine and release the hips using the criteria of each stage. The system is your roadmap.'
}, {
  n: '3',
  title: 'Shield your spine for good',
  desc: 'Return to sitting, walking and lifting without fear — then lock in the Iron Core routines so the pain never comes back.'
}];
export function Steps() {
  return <section aria-label="How it works" className="bg-transparent" data-id="element-153" data-mp="fpxsx1sz3253">
      <div className="mx-auto max-w-4xl px-5 py-12" style={{
      paddingTop: "12px",
      paddingBottom: "17px"
    }} data-id="element-154" data-mp="261lm0y9rzr8e">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-155" data-mp="2a2fabsr4r81t">
          How You'll Progress Starting Today
        </h2>
        <p className="mt-3 text-center text-sm text-plum/60" data-id="element-156" data-mp="1q8zgsth2xaix">In just 3 simple steps</p>

        <ol className="mt-10 space-y-4" data-id="element-157" data-mp="1la6dtuzf51x0">
          {steps.map((s, i) => <motion.li key={s.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-4 rounded-2xl border border-grape/15 bg-white p-5" data-id="element-158" data-mp="2003wjvekwzet" data-mpi={i}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-grape font-display text-base font-black text-white" data-id="element-159" data-mp="1hae4hg27arql">
                {s.n}
              </span>
              <div data-id="element-160" data-mp="2spkkafr97s4p">
                <h3 className="text-base font-bold text-plum" data-id="element-161" data-mp="2sp1efxevou71">{s.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-162" data-mp="2nqzuzbdjisv1">{s.desc}</p>
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}